import {
  FETCH_TRACKED_KEYWORDS_IN_PROGRESS,
  FETCH_TRACKED_KEYWORDS_SUCCESSFUL,
  FETCH_TRACKED_KEYWORDS_FAILED,
  FETCH_TRACKED_KEYWORDS_COUNT_IN_PROGRESS,
  FETCH_TRACKED_KEYWORDS_COUNT_SUCCESSFUL,
  FETCH_TRACKED_KEYWORDS_COUNT_FAILED,
  FETCH_TOP_DOMAINS_IN_PROGRESS,
  FETCH_TOP_DOMAINS_SUCCESSFUL,
  FETCH_TOP_DOMAINS_FAILED,
  FETCH_KEYWORD_OVERVIEW_IN_PROGRESS,
  FETCH_KEYWORD_OVERVIEW_SUCCESSFUL,
  FETCH_KEYWORD_OVERVIEW_FAILED,
  CHANGE_SEO_DB_IN_PROGRESS,
  CHANGE_SEO_DB_SUCCESSFUL,
  CHANGE_SEO_DB_FAILED,
  DELETE_KEYWORD_IN_PROGRESS,
  DELETE_KEYWORD_SUCCESSFUL,
  DELETE_KEYWORD_FAILED,
  ADD_KEYWORDS_IN_PROGRESS,
  ADD_KEYWORDS_SUCCESSFUL,
  ADD_KEYWORDS_FAILED
} from "./types";

export const fetchTrackedKeywordsInProgress = guid => ({
  type: FETCH_TRACKED_KEYWORDS_IN_PROGRESS,
  guid: guid
});

export const fetchTrackedKeywordsSuccessful = (guid, keywords, seo_db) => ({
  type: FETCH_TRACKED_KEYWORDS_SUCCESSFUL,
  guid: guid,
  keywords: keywords,
  seo_db: seo_db
});

export const fetchTrackedKeywordsFailed = guid => ({
  type: FETCH_TRACKED_KEYWORDS_FAILED,
  guid: guid
});

export const fetchTrackedKeywordsCountInProgress = () => ({
  type: FETCH_TRACKED_KEYWORDS_COUNT_IN_PROGRESS
});

export const fetchTrackedKeywordsCountSuccessful = keywords_count => ({
  type: FETCH_TRACKED_KEYWORDS_COUNT_SUCCESSFUL,
  keywords_count: keywords_count
});

export const fetchTrackedKeywordsCountFailed = () => ({
  type: FETCH_TRACKED_KEYWORDS_COUNT_FAILED
});

export const fetchTopDomainsInProgress = h_key => ({
  type: FETCH_TOP_DOMAINS_IN_PROGRESS,
  h_key: h_key
});

export const fetchTopDomainsSuccessful = (h_key, guid, keyword, top_domains) => ({
  type: FETCH_TOP_DOMAINS_SUCCESSFUL,
  h_key: h_key,
  guid: guid,
  keyword: keyword,
  top_domains: top_domains
});

export const fetchTopDomainsFailed = h_key => ({
  type: FETCH_TOP_DOMAINS_FAILED,
  h_key: h_key
});

export const fetchKeywordOverviewInProgress = h_key => ({
  type: FETCH_KEYWORD_OVERVIEW_IN_PROGRESS,
  h_key: h_key
});

export const fetchKeywordOverviewSuccessful = (h_key, guid, keyword, overview) => ({
  type: FETCH_KEYWORD_OVERVIEW_SUCCESSFUL,
  h_key: h_key,
  guid: guid,
  keyword: keyword,
  overview: overview
});

export const fetchKeywordOverviewFailed = h_key => ({
  type: FETCH_KEYWORD_OVERVIEW_FAILED,
  h_key: h_key
});

export const changeSeoDbInProgress = guid => ({
  type: CHANGE_SEO_DB_IN_PROGRESS,
  guid: guid
});

export const changeSeoDbSuccessful = (guid, new_seo_db) => ({
  type: CHANGE_SEO_DB_SUCCESSFUL,
  guid: guid,
  new_seo_db: new_seo_db
});

export const changeSeoDbFailed = guid => ({
  type: CHANGE_SEO_DB_FAILED,
  guid: guid
});

export const deleteKeywordInProgress = (guid, keyword) => ({
  type: DELETE_KEYWORD_IN_PROGRESS,
  guid: guid,
  keyword: keyword
});

export const deleteKeywordSuccessful = (guid, keyword) => ({
  type: DELETE_KEYWORD_SUCCESSFUL,
  guid: guid,
  keyword: keyword
});

export const deleteKeywordFailed = (guid, keyword) => ({
  type: DELETE_KEYWORD_FAILED,
  guid: guid,
  keyword: keyword
});

export const addKeywordsInProgress = domain => ({
  type: ADD_KEYWORDS_IN_PROGRESS,
  domain: domain
});

export const addKeywordsSuccessful = domain => ({
  type: ADD_KEYWORDS_SUCCESSFUL,
  domain: domain
});

export const addKeywordsFailed = domain => ({
  type: ADD_KEYWORDS_FAILED,
  domain: domain
});
